/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Injectable } from '@angular/core';
import { type BaseRequestOptionsArgs, type HttpResponse, type Rest, HttpService } from '@dm/core';
import { type UnixLocalUser } from 'app/common/types/mo';
import { type Observable } from 'rxjs';


@Injectable({ providedIn: 'root' })
export class UnixLocalAccessUserService {
    constructor(
        private http: HttpService,
    ) { }

    /**
     * 本地认证用户批量查询接口
     */
    getBatchRest(): Rest {
        return this.http.makeUrl('UnixLocalUser.getBatch', undefined, true);
    }

    /**
     * 本地认证用户数量接口
     */
    countRest(): Rest {
        return this.http.makeUrl('UnixLocalUser.count', undefined, true);
    }

    /**
     * 创建本地认证用户
     */
    create(body: UnixLocalUser, options?: BaseRequestOptionsArgs): Observable<HttpResponse> {
        const rest = this.http.makeUrl('UnixLocalUser.post');
        return this.http.post(rest, body, options);
    }

    /**
     * 修改本地认证用户
     */
    modify(body: UnixLocalUser, options?: BaseRequestOptionsArgs): Observable<HttpResponse> {
        const rest = this.http.makeUrl('UnixLocalUser.put');
        return this.http.put(rest, body, options);
    }

    /**
     * 删除本地认证用户
     */
    delete(name: string, vstoreId?: string, options?: BaseRequestOptionsArgs): Observable<HttpResponse> {
        const rest = this.http.makeUrl('UnixLocalUser.delete').setParams({ name });
        if (vstoreId) {
            rest.setParams({ vstoreId });
        }
        return this.http.delete(rest, options);
    }

    // 获取所有多租户的Rest
    getVstoreRest(): Rest {
        return this.http.makeUrl('vstore.getBatch');
    }

    // 获取单个本地认证用户
    get(name: string, vstoreId?: string, options?: BaseRequestOptionsArgs): Observable<HttpResponse> {
        const rest = this.http.makeUrl('UnixLocalUser.get');
        const params: UnixLocalUser = { name };
        if (vstoreId) {
            params.vstoreId = vstoreId;
        }
        rest.setParams(params);
        return this.http.get(rest, options);
    }
}
